import { render, staticRenderFns } from "./UserTopSections.vue?vue&type=template&id=539bdcae&"
import script from "./UserTopSections.vue?vue&type=script&lang=js&"
export * from "./UserTopSections.vue?vue&type=script&lang=js&"
import style0 from "./UserTopSections.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports